// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VqhMk","colBig":"styles_colBig__2RskI","colSmall":"styles_colSmall__2sIxy","shopifyNameWrapper":"styles_shopifyNameWrapper__2GnV7"};